module.exports = __webpack_public_path__ + "img/img1.5140120a.png";